import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Question4.css";
import Clock from "./images/clock.gif";

const Question4 = ({ onAnswer, userResponse }) => {
  const question = {
    title:
      "If You Had The Chance To Complete Your Research Faster While Maintaining High Quality, How Much Would That Save You in Terms of Time and Stress?",
    questionImage: Clock,
    options: [
      { label: "A few days", image: "" },
      { label: "A few weeks", image: "" },
      { label: "A few months", image: "" },
      { label: "I’m not sure, but it would change everything", image: "" },
    ],
  };

  const handleNext = () => {
    if (!userResponse[question.title]) {
      return;
    }

    setTimeout(() => {
      onAnswer(question.title, null);
    }, 1000);
  };

  return (
    <AnimatePresence>
      <motion.div
        className="question4-container"
        initial={{ opacity: 0, x: "10%" }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: "-100vw" }}
        transition={{ duration: 1 }}
      >
        {question.questionImage && (
          <motion.img
            className="question4-img"
            src={question.questionImage}
            alt="Question"
            initial={{ opacity: 0, x: "10%" }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: "-100vw" }}
            transition={{ duration: 0.5 }}
          />
        )}

        <motion.h2
          className="question4-head"
          initial={{ opacity: 0, x: "10%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: "-100vw" }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          {question.title}
        </motion.h2>

        <div className="option4-container">
          {question.options.map((option, index) => (
            <motion.label
              key={index}
              className={`radio4-option ${
                userResponse[question.title] === option.label ? "checked" : ""
              }`}
              htmlFor={`option-${index}`}
              initial={{ opacity: 0, x: "10%" }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: "-100vw" }}
              transition={{
                duration: 0.5,
                delay: 0.5,
              }}
            >
              <input
                type="radio"
                id={`option-${index}`}
                name={`question-${question.title}`}
                value={option.label}
                checked={userResponse[question.title] === option.label}
                onChange={() => onAnswer(question.title, option.label)}
              />
              <span className="radio4-label">{option.label}</span>
            </motion.label>
          ))}
        </div>

        <motion.button
          type="submit"
          initial={{ opacity: 0, x: "10%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: "-100vw" }}
          transition={{ duration: 0.5, delay: 1 }}
          onClick={handleNext}
          disabled={!userResponse[question.title]}
        >
          Next Question
        </motion.button>
      </motion.div>
    </AnimatePresence>
  );
};

export default Question4;
